import { useState } from 'react';
import { similarFilterTags, similarMovies } from '@/mocks/similarMovies';
import SectionHeading from './SectionHeading';

export default function SimilarSection() {
  const [activeTag, setActiveTag] = useState('全部');

  const visibleMovies =
    activeTag === '全部' ? similarMovies : similarMovies.filter((movie) => movie.tags.includes(activeTag));

  return (
    <section id="similar" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          eyebrow="06 / 类似电影推荐"
          title="看完这部，还可以看什么"
          desc="以下作品在题材、年代或演员上与《蜜桃成熟时》有所交集，可作为延伸观影的参考。点击标签即可在本页筛选。"
        />

        <div className="mt-6 flex flex-wrap gap-2" role="tablist" aria-label="类似电影筛选">
          {similarFilterTags.map((tag) => {
            const active = tag === activeTag;
            return (
              <button
                key={tag}
                type="button"
                role="tab"
                aria-selected={active}
                onClick={() => setActiveTag(tag)}
                className={`rounded-full border px-4 py-1.5 font-label text-sm whitespace-nowrap transition-colors ${
                  active
                    ? 'border-primary-500 bg-primary-500 text-background-50'
                    : 'border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
                }`}
              >
                {tag}
              </button>
            );
          })}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {visibleMovies.map((movie) => (
            <article
              key={movie.title}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="h-52 w-full overflow-hidden md:h-60">
                <img
                  src={movie.image}
                  alt={`${movie.title}（${movie.year}）氛围示意图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 md:text-lg">{movie.title}</h3>
                  <span className="font-label text-xs text-foreground-500">{movie.year}</span>
                </div>
                <p className="mt-1 font-label text-xs text-foreground-500">{movie.creator}</p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{movie.desc}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {movie.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-xs text-accent-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        {visibleMovies.length === 0 ? (
          <p className="mt-8 text-center font-label text-sm text-foreground-500">该标签下暂无推荐，试试其他分类。</p>
        ) : null}
      </div>
    </section>
  );
}